import Payments from "../../../../../../dto/Payments"

export enum ActionType {
    PAYMENTS_LOADING = 'PAYMENTS_LOADING',
    PAYMENTS_DATA = 'PAYMENTS_DATA',
    PAYMENTS_ERROR = 'PAYMENTS_ERROR'
}

export interface ActionPayments {
    type: ActionType.PAYMENTS_DATA,
    list: Payments[]
}

export interface ActionPaymentsFetchError {
    type: ActionType.PAYMENTS_ERROR,
    message: String
}


type Action = ActionPayments | ActionPaymentsFetchError

export default Action